import type { FC } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Box, Card, NotificationBox, Skeleton, Stack } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DynamicPricingTariffsRendering } from '@sitecore/types/DynamicPricingTariffs';

import { Graph } from './Graph';
import { DateControls } from './subcomponents/DateControls/DateControls';
import { GraphControls } from './subcomponents/GraphControls';
import { useDynamicPricingTariffsOptional } from '../../hooks/useDynamicPricingTariffs';
import { Legend } from './subcomponents/Legend/Legend';

export const GraphView: FC = () => {
  const { fields } = useContent<DynamicPricingTariffsRendering>();
  const { format } = useFormatter();
  const context = useDynamicPricingTariffsOptional();

  if (!context) return null;
  const { data, hasError, isLoading, productTypes, selectedProduct, start } = context;

  return (
    <>
      {productTypes && productTypes?.length > 0 ? <GraphControls /> : null}
      {hasError || (!isLoading && !data?.length) ? (
        <NotificationBox
          title={fields?.errorNotification?.value?.title}
          text={format(fields?.errorNotification?.value?.content, {
            productLabel: selectedProduct ? fields?.[`${selectedProduct}ProductLabel`]?.value?.toLocaleLowerCase() : '',
          })}
          isAlert
          variant={fields?.errorNotification?.value?.variant}
        />
      ) : null}
      <Card>
        <Stack gap="6">
          {start ? <DateControls /> : <Skeleton width="100px" />}
          {isLoading || !selectedProduct ? (
            <Box paddingX="8">
              <Skeleton height={400} />
            </Box>
          ) : (
            <>
              <Graph />
              <Legend />
            </>
          )}
        </Stack>
      </Card>
    </>
  );
};
